<template>
  <div class="page-wrap">
    <div class="session-form-hold">
      <base-card>
        <v-card-text class="text-center">
          <img
            class="pt-3 pb-3"
            alt="Noisypeak Logo"
            src="/images/Noisypeak_Playout_Logo_20_beta_b.png"
            style="width: 330px;"
          >
          <div
            v-if="error"
            class="text-center"
            style="color: red;"
          >
            Invalid login or password
          </div>
          <v-text-field
            v-model.trim="login"
            label="Login"
            :rules="[rules.required]"
            required
          />
          <v-text-field
            v-model.trim="password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            label="Password"
            :rules="[rules.required]"
            required
            @click:append="show = !show"
          />
          <v-btn
            large
            block
            :disabled="isLoaded || !isFormValid"
            class="mb-4"
            color="success"
            @click="onSubmit"
          >
            Sign In
          </v-btn>
        </v-card-text>
      </base-card>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'SignIn',
    metaInfo: {
      title: 'Sign In',
    },
    data () {
      return {
        show: false,
        password: 'Password',
        login: '',
        error: '',
        isLoaded: false,
        rules: {
          required: (value) => !!value || 'Required',
        },
      }
    },
    computed: {
      isFormValid () {
        return (this.login.length >= 0 && this.password.length >= 0)
      },
    },
    methods: {
      onSubmit () {
        this.isLoaded = true
        this.$store.dispatch('login', { username: this.login, password: this.password })
          .then(() => {
            this.$router.push({ name: 'DashboardPage' })
          })
          .catch((errorMsg) => {
            this.error = errorMsg
          })
          .finally(() => {
            this.isLoaded = false
          })
      },
    },
  }
</script>

<style lang="scss" scoped>
.page-wrap {
    background-color: #f7f7f7 !important;
    display: flex;
    align-items: center;
    padding: 40px 1rem;
    height: 100%;
    min-height: 100vh;
}
.session-form-hold {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
}
</style>
